import { Component, OnInit } from '@angular/core';
import { ROUTES } from './menu-items';
import { ConfigAccessCheckService } from '../services/config-access-check.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
	showMenu = '';
	showSubMenu = '';
	public sidebarnavItems: any[];

	constructor(
		private accessAuthenticationService: ConfigAccessCheckService
	) { }

	ngOnInit() {
		const hasAdminAccess = this.accessAuthenticationService.hasConfigAccess;
		this.sidebarnavItems = ROUTES.filter(sidebarnavItem =>
			!sidebarnavItem.requiresAdminAccess || (sidebarnavItem.requiresAdminAccess && hasAdminAccess));
	}
}
